import React from 'react';
import PropTypes from 'prop-types';
import capitalize from 'lodash/capitalize';

import { toCurrencyString } from '@/number';
import { useUpdateSubscriptionContext } from '@/contexts';

const propTypes = {
  periodicityText: PropTypes.string,
  renovationDate: PropTypes.string
};

const defaultProps = {
  periodicityText: '',
  renovationDate: ''
};

function CurrentSubscriptionPreview(props) {
  const {
    periodicityText,
    renovationDate
  } = props;

  const {
    currentSubscritionPreview,
    loadedCurrentSubscriptionPreview,
    subscriptionType
  } = useUpdateSubscriptionContext();


  if (!loadedCurrentSubscriptionPreview || !currentSubscritionPreview) {
    return null;
  }

  const planFullName =
  `${currentSubscritionPreview.name} ${currentSubscritionPreview.maxUsersCount}`;

  return (
    <div className='animation-fade-in-delay'>
      <h5>Plano {planFullName}</h5>

      <div>
        <span className='text-dark-gray'>Pago até: </span>
        {renovationDate}
      </div>

      <div>
        <span className='text-dark-gray'>Período: </span>
        {capitalize(periodicityText)}
      </div>

      <div>
        <span className='text-dark-gray'>Plano: </span>
        {toCurrencyString(currentSubscritionPreview.finalValue)}
      </div>

      {subscriptionType === 'chat' && currentSubscritionPreview.addonsInfo.map((addon) => (
        <div key={addon.productCode}>
          <span className='text-dark-gray'>{addon.addonName}: </span>
          {toCurrencyString(addon.value)}
        </div>
      ))}

      <div>
        <span className='text-dark-gray'>Valor total: </span>
        {toCurrencyString(currentSubscritionPreview.completeFinalValue)}
      </div>
    </div>
  );
}

CurrentSubscriptionPreview.propTypes = propTypes;
CurrentSubscriptionPreview.defaultProps = defaultProps;

export default CurrentSubscriptionPreview;
